import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import {
    getDomainValueForCode,
    getTimeAgo,
    isSchoolAdmin,
    isSuperAdmin,
    underScoreToTitleCase,
} from '../../../library/Core/SmartFunctions';
import JobListingService from './JobListingService';
import { Modal } from 'bootstrap';
import SessionContext from '../../../library/Core/SessionContext';
import ApplyNowPageConfig from './ApplyNowPageConfig.json';
import CloseJobPageConfig from './CloseJobPageConfig.json';
import IntrestedJobPageConfig from './IntrestedJobPageConfig.json';
import ApplyNowModal from './ApplyNowModal';
import ViewDescriptionModal from './ViewDescriptionModal';
import CloseJobModal from './CloseJobModal';
import IntrestedJobModal from './IntrestedJobModal';
import ViewIntrestedJobModal from './ViewIntrestedJobModal';
import ViewApplicationModal from './ViewApplicationModal';
import ViewAppliedsModal from './ViewAppliedsModal';
import SendMessageToInterestedModal from './SendMessageToIntrested';

const JobCardsControl = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { sessionState } = useContext(SessionContext);
    const jobs = state?.data?.filteredData;
    const id = sessionState?.id;

    const handleSavePreference = async (params: any) => {
        try {
            const response = await JobListingService.savePreference(params);
            console.log('API response:', response, 'Status:', response?.status);

            // If we get any response, try to update UI
            if (response) {
                const jobs = state?.data?.filteredData;
                console.log('Current jobs before update:', jobs);

                if (jobs && jobs.length > 0) {
                    // Create a completely new array to force React to detect the change
                    const modifiedJobs = jobs.map((job: any) => {
                        if (job.id == params.jobId) {
                            // Create a new object for the modified job
                            return {
                                ...job,
                                // isInterested: params.isInterested,
                                isSaved: params.isSaved,
                                isViewed: params?.isViewed,
                                totalViewedCnt: job.isViewed
                                ? job.totalViewedCnt
                                : (job.totalViewedCnt || 0) + 1,
                                // totalInterestedCnt: (job.totalInterestedCnt || 0) + 1,
                            };
                        }
                        return job;
                    });

                    // console.log('Modified jobs after update:', modifiedJobs);
                    // let sentInterest = state.data.summaryCounts?.sentInterest || 0;

                    // const intrestArray = ['IMMEDIATELY', 'EXPLORING', 'INTERESTED'];
                    // if (params?.isInterested && intrestArray.includes(params.isInterested)) {
                    //     sentInterest += 1;
                    // }
                    // Update the entire data object to ensure state change is detected
                    dispatch({
                        type: 'REFRESH_DATA',
                        payload: {
                            data: {
                                ...state.data,
                                filteredData: modifiedJobs,
                                summaryCounts: {
                                    ...state.data.summaryCounts,
                                    // sentInterest: sentInterest,
                                },
                            },
                        },
                    });
                }
            }
        } catch (error) {
            console.error('Error saving preference:', error);
        }
    };

    const handleViewJobDescription = (job: any) => {
        dispatch({ type: 'SET_MODAL_DATA', payload: { data: job } });
        dispatch({ type: 'TOGGLE_MODAL_VISIBILITY', payload: { modalName: 'showJobPostingViewDescription' } });
    };

    const handleSendMessage = (event: any, id: string) => {
        event.preventDefault();
        state.actions['ROUTER_NAVIGATE'](`/messages/send-message/${id}`);
    };
    console.log(jobs, ' jobs ');

    // appynow code her
    const [activeModal, setActiveModal] = useState(null);
    const loadPageConfig = async (configPromise: any, modalType: any) => {
        try {
            setActiveModal(null);
            const config = await Promise.resolve(configPromise);
            dispatch({
                type: 'DATA_INIT',
                payload: {
                    formConfig: config,
                    data: {
                        ...state.data,
                        jobPostingAppliedJobs: {},
                        jobPostingCloseJob: {},
                        jobPostingIntrestedJob: {},
                    },
                    domain: new Map([...state.domain]),
                    internal: state.internal,
                    routeInfo: state.routeInfo,
                },
            });

            setActiveModal(modalType);
        } catch (error) {
            console.error('Error fetching page config:', error);
        }
    };

    const handleOpenModal = async (
        job: any,
        modalType:
            | 'APPLY'
            | 'CLOSE'
            | 'INTRESTED'
            | 'VIEW_INTERESTED'
            | 'VIEW_APPLICATION'
            | 'SEND_MESSAGE_TO_INTERESTED'
            | 'VIEW_APPLIEDS',
        pageConfig?: any
    ) => {
        const notRecruiredPageconfig = ['VIEW_INTERESTED', 'VIEW_APPLICATION', 'VIEW_APPLIEDS', 'SEND_MESSAGE_TO_INTERESTED'];
        if (!notRecruiredPageconfig.includes(modalType) && pageConfig) {
            await loadPageConfig(pageConfig, modalType);
        }

        dispatch({
            type: 'SET_MODAL_DATA',
            payload: { data: job },
        });

        dispatch({
            type: 'TOGGLE_MODAL_VISIBILITY',
            payload: {
                modalName:
                    modalType === 'APPLY'
                        ? 'showJobPostingApplyNow'
                        : modalType === 'SEND_MESSAGE_TO_INTERESTED'
                        ? 'showSendMessageToInterestedModal'
                        : modalType === 'CLOSE'
                        ? 'showJobPostingCloseJob'
                        : modalType === 'INTRESTED'
                        ? 'showJobPostingIntrested'
                        : modalType === 'VIEW_APPLICATION'
                        ? 'showJobViewApplication'
                        : modalType === 'VIEW_APPLIEDS'
                        ? 'showJobViewApplieds'
                        : 'showJobViewInterested',
            },
        });
    };

    return (
        <>
            <div
                className="flex-1 polarcontsec tab-content aos-init aos-animate"
                id="myTabContent"
                data-aos="fade-left"
                data-aos-delay="900">
                <div className="tab-pane fade show active" id="JobListing" role="tabpanel" aria-labelledby="JobListing-tab">
                    <div className="JobListing_present">
                        {state?.data?.filteredData?.length > 0 && (
                            <div id="Activehtml">
                                <h3 className="font-18 font-500 mb-3 d-none d-md-block">{state?.data?.filteredData?.length} Jobs found</h3>
                                <div className="row g-3">
                                    {state.data.selectedTab == 'LISTED_BY_USER' && (
                                        <div className="col-md-12">
                                            <div className="w-100">
                                                <div className="listed-insights-wrapper xscroll">
                                                    <div className="listed-insights">
                                                        <div className="listed-insights-block d-flex flex-column">
                                                            <div className="icon-holder">
                                                                <i className="icon-listed-search font-30"></i>
                                                            </div>
                                                            <h3 className="font-35 font-600 mb-0">
                                                                {state.data.summaryCounts.viewedByOthers}
                                                            </h3>
                                                            <p className="font-16 font-400 mb-0">Total Views</p>
                                                            {/* <span className="font-14 font-400 mb-0"><i className="bi bi-arrow-up "></i> 23% this week</span> */}
                                                        </div>
                                                        <div className="listed-insights-block d-flex flex-column">
                                                            <div className="icon-holder">
                                                                <i className="bi bi-hand-thumbs-up font-30"></i>
                                                            </div>
                                                            <h3 className="font-35 font-600 mb-0">
                                                                {state.data.summaryCounts.interestedByOthers}
                                                            </h3>
                                                            <p className="font-16 font-400 mb-0">Total Interest</p>
                                                        </div>
                                                        <div className="listed-insights-block d-flex flex-column">
                                                            <div className="icon-holder">
                                                                <i className="icon-alumni font-30"></i>
                                                            </div>
                                                            <h3 className="font-35 font-600 mb-0">
                                                                {state.data.summaryCounts.interestedByOtherAlumni}
                                                            </h3>
                                                            <p className="font-16 font-400 mb-0">Alumni Interest</p>
                                                        </div>
                                                        <div className="listed-insights-block d-flex flex-column">
                                                            <div className="icon-holder">
                                                                <i className="bi bi-clipboard-check font-30"></i>
                                                            </div>
                                                            <h3 className="font-35 font-600 mb-0">
                                                                {state.data.summaryCounts.appliedByOthers}
                                                            </h3>
                                                            <p className="font-16 font-400 mb-0">Applied</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {state?.data?.filteredData.map((job: any, index: number) => (
                                        <div key={job.id} data-job-id={job.id} className="col-md-12">
                                            <div className="border rounded p-4 position-relative overflow-hidden">
                                                {job.statusCode === 'CLOSED' && (
                                                    <div className="position-absolute bg-danger text-white top-left-sticker">
                                                        <span className="font-12 font-500 lh-1"> Closed </span>
                                                    </div>
                                                )}
                                                <div className="row g-3">
                                                    <div className="col-md-12">
                                                        <div className="row align-items-center">
                                                            <div className="col-md">
                                                                <div className="font-22 font-600 text-dark-blue">
                                                                    {underScoreToTitleCase(job.jobTypeCode)}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-auto">
                                                                <div className="row g-2 align-items-center">
                                                                    <div className="col-md-auto">
                                                                        <div className="font-12 font-500 text-dark-blue">
                                                                            <i>Posted by:</i> {`${job.firstName} ${job.lastName}`},{' '}
                                                                            {job.programName} {job.passOutYear}
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-auto">
                                                                        <span className="badge text-bg-secondary bg-opacity-25 text-dark font-12 font-400 rounded-pill align-top">
                                                                            {/* {moment().diff(job.createdAt, 'days') > 0
                                                                                ? moment().diff(job.createdAt, 'days') + 'days ago'
                                                                                : 'today'} */}
                                                                            {getTimeAgo(job.createdAt)}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="bg-gray-f5f5f5 font-16 font-600 text-black px-3 py-2 rounded">
                                                            {/* {job.title} @ {job.companyName} */}
                                                            {job.title} @{' '}
                                                            {job.companyId
                                                                ? getDomainValueForCode(job.companyId, 'COMPANY_CODE', state)
                                                                : job.otherCompany}
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="row g-2">
                                                            <div className="col-auto">
                                                                <i className="bi bi-geo-alt-fill me-2 text-dark-blue"></i>
                                                                {getDomainValueForCode(job.cityCode, 'CITY_CODE', state)}
                                                            </div>
                                                            {job.experienceLevelCode && (
                                                                <div className="col-auto">
                                                                    <i className="bi bi-briefcase-fill ms-3 me-1 text-dark-blue"></i>{' '}
                                                                    {/* {job.minExperience} - {job.maxExperience} Year Experience */}
                                                                    {getDomainValueForCode(
                                                                        job.experienceLevelCode,
                                                                        'WORK_EX_PREFERENCE',
                                                                        state
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <hr className="my-2 opacity-25" />
                                                        <div className="row g-2">
                                                            <div className="col-auto">
                                                                <i className="bi bi-eye me-2 text-dark-blue"></i> {job.totalViewedCnt} views
                                                            </div>
                                                            <div className="col-auto">
                                                                <i className="bi bi-star ms-3 me-2 text-warning"></i>{' '}
                                                                {job.totalInterestedCnt} interested
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="row g-2">
                                                            <div className="col-auto">
                                                                <button
                                                                    className="btn btn-dark-blue font-14 font-500 text-white w-auto height-35"
                                                                    onClick={() => {
                                                                        handleViewJobDescription(job);
                                                                        if (!isSchoolAdmin() && (job.studentId != sessionState?.id)) {
                                                                            handleSavePreference({
                                                                                jobId: job?.id,
                                                                                isSaved: job?.isSaved,
                                                                                isViewed: 1,
                                                                            });
                                                                        }
                                                                    }}>
                                                                    <span>View Job Description</span>
                                                                </button>
                                                            </div>
                                                            {!job.isInterested &&
                                                                job.studentId != sessionState?.id &&
                                                                !isSchoolAdmin() &&
                                                                sessionState?.userTypeCode !== 'SUPER_ADMIN' && (
                                                                    <div className="col-auto">
                                                                        <button
                                                                            className="btn btn-gold-f1ac18 rounded-pill font-14 font-500 text-white height-35 px-4"
                                                                            onClick={() =>
                                                                                handleOpenModal(job, 'INTRESTED', IntrestedJobPageConfig)
                                                                            }>
                                                                            <span>I'm Interested</span>
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            {job.isInterested &&
                                                                job.studentId != sessionState?.id &&
                                                                !isSchoolAdmin() &&
                                                                sessionState?.userTypeCode !== 'SUPER_ADMIN' && (
                                                                    <div className="col-auto">
                                                                        <button
                                                                            className="btn btn-border-gray rounded-pill font-14 font-500 height-35 px-4"
                                                                            onClick={(event) => handleSendMessage(event, job.studentId)}>
                                                                            <span>Follow-up</span>
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            {!isSchoolAdmin() && job.isApplied == 0 && job.studentId != sessionState?.id && (
                                                                <div className="col-auto">
                                                                    <button
                                                                        className="btn btn-green font-14 font-500 text-white height-35"
                                                                        onClick={() => handleOpenModal(job, 'APPLY', ApplyNowPageConfig)}>
                                                                        <span>Apply Now</span>
                                                                    </button>
                                                                </div>
                                                            )}
                                                            {job.isApplied == 1 && (
                                                                <div className="col-auto">
                                                                    <button
                                                                        className="btn btn-green font-14 font-500 text-white height-35"
                                                                        onClick={() => handleOpenModal(job, 'VIEW_APPLICATION')}>
                                                                        <span>View Application</span>
                                                                    </button>
                                                                </div>
                                                            )}
                                                            {job.studentId == sessionState?.id && job.statusCode != 'CLOSED' && (
                                                                <div className="col-auto">
                                                                    <button
                                                                        className="btn btn-danger rounded-pill font-14 font-500 text-white height-35 px-4"
                                                                        onClick={() => handleOpenModal(job, 'CLOSE', CloseJobPageConfig)}>
                                                                        <span>Close Job</span>
                                                                    </button>
                                                                </div>
                                                            )}

                                                            {job.studentId === sessionState?.id && job.totalInterestedCnt > 0 && (
                                                                <div className="col-auto">
                                                                    <button
                                                                        className="btn btn-green font-14 font-500 text-white height-35"
                                                                        onClick={() => handleOpenModal(job, 'VIEW_INTERESTED')}>
                                                                        <span>View Interested ({job.totalInterestedCnt})</span>
                                                                    </button>
                                                                </div>
                                                            )}

                                                            {job.studentId === sessionState?.id && job.totalInterestedCnt > 0 && (
                                                                <div className="col-auto">
                                                                    <button
                                                                        className="btn btn-gold-f1ac18 rounded-pill font-14 font-500 text-white height-35 px-4"
                                                                        onClick={() => handleOpenModal(job, 'SEND_MESSAGE_TO_INTERESTED')}>
                                                                        <span>Message All ({job.totalInterestedCnt})</span>
                                                                    </button>
                                                                </div>
                                                            )}

                                                            {job.studentId === sessionState?.id && job.totalApplicantCnt > 0 && (
                                                                <div className="col-auto">
                                                                    <button
                                                                        className="btn btn-green font-14 font-500 text-white height-35"
                                                                        onClick={() => handleOpenModal(job, 'VIEW_APPLIEDS')}>
                                                                        <span>View Applied ({job.totalApplicantCnt})</span>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row m-0 d-flex flex-wrap justify-content-between align-items-end">
                                                <div className="pe-0 text-end">
                                                    <div className="d-flex flex-wrap justify-content-end"></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {jobs.length === 0 && (
                            <div className="no_listed_items_blk">
                                <div className="mt-0">
                                    <div className="max-470 mx-auto">
                                        <img
                                            className="mt-2 mb-4 float_horizontal_animate"
                                            src={`${process.env.REACT_APP_IMAGE_BASEPATH}/no_messages.svg`}
                                        />
                                        <p className="font-18 font-400 mb-4 text-center">Sorry! No jobs found.</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {/* Modal for View Description */}
            <ViewDescriptionModal />
            {/* Modal for Apply Now */}
            {activeModal === 'APPLY' && <ApplyNowModal />}
            {activeModal === 'CLOSE' && <CloseJobModal />}
            {activeModal === 'INTRESTED' && <IntrestedJobModal />}{' '}
            {state?.modalFlags?.showJobViewInterested && <ViewIntrestedJobModal handleOpenModal={handleOpenModal} />}
            {state?.modalFlags?.showJobViewApplication && <ViewApplicationModal />}
            {state?.modalFlags?.showJobViewApplieds && <ViewAppliedsModal handleOpenModal={handleOpenModal} />}
            {state?.modalFlags?.showSendMessageToInterestedModal && <SendMessageToInterestedModal handleOpenModal={handleOpenModal} />}
        </>
    );
};

export default JobCardsControl;
